<template>
    <div class="page-customer page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="12">
                    <h3 style="float: none;">员工管理</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>员工管理</el-breadcrumb-item>
                            <el-breadcrumb-item>员工列表</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
				<el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
				    <el-button type="primary" class="btn-bg-p" @click="handleStaff('add')">添加 <i class="el-icon-plus"></i></el-button>
				</el-col>
            </el-row>
            <div class="bd">
                <div class="search-block content-body">
                    <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
                        <!--<el-form-item prop="id" label="ID：" style="margin-bottom: 0;">
                            <el-input v-model="form_search.id" size="small" placeholder="频道ID" clearable></el-input>
                        </el-form-item>-->
                        <el-form-item prop="userName" label="员工姓名：" style="margin-bottom: 0;">
                            <el-input v-model="form_search.userName" size="small" placeholder="员工姓名" clearable></el-input>
                        </el-form-item>
                       
                        <el-form-item style="margin-bottom: 0;">
                            <el-button type="primary" class="search-btn"  size="medium" @click='searchList()'>查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;">
                            <el-table-column prop="icode" width="80" label="icode" align="center"></el-table-column>
                            <el-table-column prop="userName" align="center" label="用户姓名" min-width="140">
                            </el-table-column>
                            <el-table-column prop="orgShortName" align="center" label="部门简称" min-width="120">
                            </el-table-column>
							<el-table-column prop="sort" align="center" label="排序" min-width="120">
							</el-table-column>
                            <el-table-column prop="createdate" align="center" label="创建时间" min-width="160">
                            </el-table-column>
                            <el-table-column prop="operating" align="center" label="操作" min-width="100" fixed="right">
                                <template slot-scope="scope">
                                    <el-button class="option-btn btn-bd-s" type="primary" size="mini" @click="handleStaff('edit',scope.row)">编辑</el-button>							
                                    <el-button class="option-btn btn-bd-r" type="primary" size="mini" @click="deleteStaff(scope.row.icode)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.pageNo"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
            </div>
        </div>
		<el-dialog class="dialog-export goods-dialog" :title="dlg_staff.title" :visible.sync="dlg_staff.visible" width="600px" @closed="closeGoods" :close-on-click-modal="false">
		    <el-form ref="formStaff" :model="dlg_staff.form" label-width="120px" :rules="dlg_staff.rules" @submit.native.prevent>
		        <el-row style="margin-top: 15px;" :gutter="20">
		            <el-col :span="24">
		                <el-form-item prop="userName" label="员工姓名：" :error="dlg_staff.error.userName">
		                    <el-input size="small" v-model="dlg_staff.form.userName" placeholder='请输入员工姓名' clearable></el-input>
		                </el-form-item>
		            </el-col>
				</el-row>
				<el-row :gutter="20">
				    <el-col :span="24">
				        <el-form-item prop="orgShortName" label="部门简称" :error="dlg_staff.error.orgShortName">
				            <el-input size="small" type='text' v-model="dlg_staff.form.orgShortName" clearable></el-input>
				        </el-form-item>
				    </el-col>
				</el-row>
		        <el-row :gutter="20">
		            <el-col :span="24">
		                <el-form-item prop="sort" label="排序：" :error="dlg_staff.error.sort">
		                    <el-input size="small" type='number' v-model="dlg_staff.form.sort" placeholder='请输入排序（输入数字）' clearable></el-input>
		                </el-form-item>
		            </el-col>
		        </el-row>
		    </el-form>
		    <span slot="footer" class="dialog-footer">
		        <el-button @click="dlg_staff.visible = false">取 消</el-button>
		        <el-button type="primary" @click="submitStaff()" :loading="dlg_staff.btn_loading">确认</el-button>
		    </span>
		</el-dialog>
   </div>
</template>
<script>
    export default {
        name: 'usercenter',
        data() {
            return {
                clientHeight:'',
                body_loading:false,
                is_refresh: true,
                //搜索
                form_search:{
                    userName:"",
                   
                },
               
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        pageNo: 1,
                        pageSize: 30,
                        total: 130
                    }
                },
				dlg_staff:{
				    id:'',
				    visible:false,
				    btn_loading:false,
				    api: '',
				    title:'',
				    form:{
						icode:'',
				        userName:'',
						orgShortName:'',
				        sort:'',
						createdate:'',
						updatedate:''
				    },
				    error:{
				        userName:'',
						orgShortName:'',
				        sort:'',
				    },
				    reset_form: {},
				    rules:{
				        userName:{required: true, message: '请输入员工姓名', trigger: ['change','blur']},
				        orgShortName:{required: true, message: '请选择员工部门', trigger: ['change','blur']},
						sort:{required: true, message: '请输入排序（输入数字）', trigger: ['change','blur']},
				        
				    },
				},
            }
        },
        created() {
            document.title = '员工管理';
            this.getList();
        },
        methods: {
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
			//关闭编辑或新政
			 closeGoods(){
				for(var key in this.dlg_staff.form){
					this.dlg_staff.form[key] = this.dlg_staff.reset_form[key];
				}
				this.$nextTick(()=>{
					this.$refs.formStaff.clearValidate();
			})
			},
			//编辑或新增
			handleStaff(type,data){
			    this.dlg_staff.visible = true;
			    if(type == 'add'){
			        this.dlg_staff.title = '添加员工';
			        this.dlg_staff.api = '/api/biz/taili/emp/save';
			    }else{
			        this.dlg_staff.id= data.icode;
			        this.dlg_staff.title = '编辑员工';
			        if(data){
			            for(var key in this.dlg_staff.form){
			                this.dlg_staff.form[key] = data[key];
			            }
					}
					this.dlg_staff.api = '/api/biz/taili/emp/save';
			    }
			},
			//提交员工信息
			submitStaff(){
			    var _this = this;
			    _this.$refs['formStaff'].validate((valid) => {
			        if (valid) {
			            this.dlg_staff.btn_loading = true;
			            this.$client.post(this.dlg_staff.api, this.dlg_staff.form, function(res,message){
			                //console.log(res)
			                _this.$message(message);
			                _this.getList();
			                _this.dlg_staff.btn_loading = false;
			                _this.dlg_staff.visible = false;
			            }, function(message){
			                _this.dlg_staff.btn_loading = false;
			                if((typeof message)==='object'){
			                    for(var key in message){
			                        _this.dlg_staff.error[key] = message[key];
			                    }
			                }
			            });
			        } else {
			            console.log('error submit!!');
			    return false;
			}
			});
			},
            getList() {
                var _this = this;
                var params = _this.form_search;
                params.pageNo = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                _this.table_data.loading = true;
                // var status_list = [{id:-1, name: '全部'}];
                this.$client.get('/api/biz/taili/emp/getList', params, function(res,message,total,totalPages){
					console.log("热水",res,total)
                    _this.table_data.list = res;
                    _this.table_data.page_info.total = total;
					 // _this.table_data.page_info.total = total;
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
			//删除员工
			deleteStaff(id){
			    var _this = this;
			    this.$confirm('确定要删除？', "", {
			                confirmButtonText: "确定",
			                cancelButtonText: "取消",
			                iconClass:"icon-delete el-icon-delete",
			                customClass:"my-confirm-box",
			                center: true,
			            })
			            .then(() => {
			        _this.$client.post('/api/biz/taili/emp/delete', {icode:id}, function(res,message){
			        _this.getList();
			    },function(res){
			
			    });
			})
			.catch(() => {});
			},
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.table_data.page_info.page = val;
                this.getList();
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            }
        }
    }
</script>
<style>

</style>
<style scoped>

</style>